import React, { useEffect, useState } from 'react';
import AutocompleteField from 'eventbrite_design_system/autocompleteField/AutocompleteField';
import InputField from 'eventbrite_design_system/inputField/InputField';

const BareAutocompleteField = ({ id, placeholder, prefix }) => (
    <div className="eds-autocomplete-field" data-spec="autocompletefield-field">
        <div className="eds-autocomplete-field__dropdown-holder">
            <InputField
                id={id}
                style="basic"
                label="autocomplete"
                placeholder={placeholder}
                prefix={prefix}
            />
        </div>
    </div>
);

export default function AutocompleteFieldWithFallback(props) {
    const [isInBrowser, setIsInBrowser] = useState(false);

    useEffect(() => setIsInBrowser(true));

    return isInBrowser ? (
        <AutocompleteField {...props} />
    ) : (
        <BareAutocompleteField {...props} />
    );
}
